// extracted by mini-css-extract-plugin
export default {"container":"SearchBarSimple_container__Iw8qX","bg":"SearchBarSimple_bg__62R60","bar":"SearchBarSimple_bar__NtdjU"};